// 封装所有与用户相关的网络请求
import request from "@/utils/request";

// 接口日志列表
export function tApiLogpageApi(data) {
    return request({
        url: "/api/tApiLog/page",
        method: "post",
        params: data
    })
}

// 接口类型
export function tApiLoginterTypeApi(data){
    return request({
        url:"/api/tApiLog/interType",
        method: "post",
        params: data
    })
}

// 重新发送
export function tApiLogprocessListApi(data){
    return request({
        url:"/api/tApiLog/processList",
        method: "post",
        data: data
    })
}

// 接口来源
export function tApiLogoutAppListApi(data){
    return request({
        url:"/api/tApiLog/outAppList",
        method: "post",
        params: data
    })
}

// 日志接口导出
export function tApiLogexportApi(data){
    return request({
        url:"/api/tApiLog/export",
        method: "post",
        params: data
    })
}

// 日志接口导出下载列表
export function reportexportListApi(data){
    return request({
        url:"/api/report/exportList",
        method: "post",
        data: data
    })
}